import { QueueDepthChart } from 'components/Chart/QueueDepthChart/QueueDepthChart'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { QueueDepthChartContent } from './QueueHealth.styled'
import { DisplayCard } from 'components/DisplayCards/DisplayCard'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { Flex, MainHeadline, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import {
    BACKLOG_CONTRIBUTORS,
    IBacklogContributorRow,
    QUEUE_DEPTH_BUCKETS,
    QUEUE_DEPTH_PEAK,
} from './queueHealthData'

const backlogColumns: IHonestTableColumn<IBacklogContributorRow>[] = [
    {
        id: 'plan',
        header: 'Plan',
        minWidth: '14rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.name}</BodyText>
                <OtherText grey>{item.backlogShare}</OtherText>
            </Cell>
        ),
    },
    {
        id: 'depth',
        header: 'Depth',
        align: 'right',
        cell: (item) => (
            <RightCell>
                <BodyText weight='600'>{item.depth}</BodyText>
            </RightCell>
        ),
    },
    {
        id: 'medianMin',
        header: 'Median min',
        align: 'right',
        cell: (item) => (
            <RightCell>
                {item.medianMin} min
            </RightCell>
        ),
    },
]

export const QueueHealth = () => {

    const [selectedPeriod, setSelectedPeriod] = useState('Today')
    const [selectedView, setSelectedView] = useState('By Plan')
    return <>
        <NavBar />
        <PageWrapper>
            <Flex width='100%' between >
                <MainHeadline>Queue Health</MainHeadline>
                <Flex gap='1rem' >
                    <TabsContainer>
                        <Tabs onClick={() => setSelectedPeriod('Today')} active={selectedPeriod === 'Today'} >Today</Tabs>
                        <Tabs onClick={() => setSelectedPeriod('Last 7 Days')} active={selectedPeriod === 'Last 7 Days'} >Last 7 Days</Tabs>
                        <Tabs onClick={() => setSelectedPeriod('Last Month')} active={selectedPeriod === 'Last Month'} >Last Month</Tabs>
                    </TabsContainer>
                    <TabsContainer>
                        <Tabs onClick={() => setSelectedView('By Plan')} active={selectedView === 'By Plan'} >By Plan</Tabs>
                        <Tabs onClick={() => setSelectedView('By Department')} active={selectedView === 'By Department'} >By Department</Tabs>
                    </TabsContainer>
                </Flex>
            </Flex>
            <Flex mt='32' gap='1rem' >
                <DisplayCard value='N/A' label='Avg queue depth' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='Peak queue depth' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='Median cycle time' borderColor='#ff9900' />
                <DisplayCard value='N/A' label='SLA breaches' borderColor='#ff9900' />
            </Flex>
            <Flex gap='1rem' mt='32' >
                <Container style={{ flex: 1 }}>
                    <ContainerHeader padding>
                        <Flex column gap='0.25rem'>
                            <TitleText weight='bold'>Queue depth over time</TitleText>
                            <BodyText grey>Today · 24 buckets · peak {QUEUE_DEPTH_PEAK}</BodyText>
                        </Flex>
                    </ContainerHeader>
                    <QueueDepthChartContent>
                        <QueueDepthChart data={QUEUE_DEPTH_BUCKETS} height='10rem' />
                    </QueueDepthChartContent>
                </Container>
                <Container style={{ flex: 1 }}>
                    <ContainerHeader padding>
                        <Flex column gap='0.25rem'>
                            <TitleText weight='bold'>Top backlog contributors</TitleText>
                            <BodyText grey>Plans sorted by current queue depth.</BodyText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent gap='0'>
                        <HonestTable
                            columns={backlogColumns}
                            data={BACKLOG_CONTRIBUTORS}
                            keyField='id'
                        />
                    </ContainerContent>
                </Container>
            </Flex>
        </PageWrapper>
    </>
}